<?php

// autoload.php @generated by Composer

require_once __DIR__ . '/composer/autoload_real.php';

return ComposerAutoloaderInit8d5540c18bbc9e77b2c163a015ed4b59::getLoader();
